webpackJsonp([153992314246253],{

/***/ 1817:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"InvoiceLineItemReason","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-invoice-line-item-reason-74faf6f0cbef7c524ac6.js